<template>
    <div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"></swb-result-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import appConf from '../../app.conf';

    import devcDefApi from '../../api/devcDef'

    export default {
        name: 'swb-mercht-devc-manual-detail',
        desc: '资料手册详情',
        props: ["defId"],
        data: function () {
            return {
                //
                confKey: 'swb-mercht-devc-manual-list',
                theTableHeight: 550,
                //
                needPager: false, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: true, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                //
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 100,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                //
                devcFiles: []
            }
        },
        created: function () {
            //
            this.getDevcDefManualDetail();
        },
        mounted() {
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        if(true) {
                            domHtml = domHtml + '<a name="view" class="swb-btn swb-btn-link">预览</a>';
                        }
                        if(true) {
                            domHtml = domHtml + '<a name="download" class="swb-btn swb-btn-link">下载</a>';
                        }
                        return domHtml;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'download') { // 下载
                            self.downloadManual(row);
                        } else if(btnName == 'view') {
                            self.viewManual(row);
                        }
                    }
                });
            },
            renderTable(rows) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows
                };

                resultTable.render(tableData);
            },
            // 查看资产定义详情
            getDevcDefManualDetail: function () {
                let self = this;
                //
                let postData = {};
                postData.devcDefId = self.defId;
                //
                let msgBoxDlg = MsgBox.loading();
                devcDefApi.getMerchtDevcManuals(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let devcFiles = result.data;
                        self.devcFiles = Utils.merge([], devcFiles);
                        self.renderTable(devcFiles);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 资料手册预览
            viewManual: function (row) {
                let fileUuid = row.fileUuid;
                if(Utils.isNoB(fileUuid)) {
                    MsgBox.warning("未找到要下载的文章！");
                    return;
                }
                let fileName = row.fileName;
                let viewUrl = appConf.makeViewableDocUrl(fileName, fileUuid);
                if(viewUrl == null) {
                    MsgBox.warning("此文件不支持在线查看！");
                }
                else {
                    Utils.setPageUrl(viewUrl, '_blank');
                }
            },
            // 资料手册下载
            downloadManual: function (row) {
                let fileUuid = row.fileUuid;
                if(Utils.isNoB(fileUuid)) {
                    MsgBox.warning("未找到要下载的文章！");
                    return;
                }
                Utils.downloadFile(getAppUrl("/file/download?uuid=" + row.fileUuid));
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcManualDetail.vue